
<div class="simple-video-player-div">
    <div>
        <div>
            <h3 [innerHTML]="videoMessageTitle"></h3>
            <p [innerHTML]="videoMessage"></p>
        </div>
    </div>
</div>